function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import { variables } from '@domain-group/fe-brary';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import { AllhomesListingBadges } from '@domain-group/fe-co-allhomes-listing-badges';
import { MultipleListingCardImage } from './multiple-listing-card-image';
import * as styles from './multiple-listing-card.style';
import { AllhomesListingCardAddress, AllhomesListingCardFeatures } from '../search-result-card/components';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var MultipleListingCard = _ref => {
  var _listing$nextInspecti, _listing$url, _listing$url2, _ref3, _agency$name;
  var listing = _ref.listing,
    address = _ref.address,
    property = _ref.property,
    _ref$agency = _ref.agency,
    agency = _ref$agency === void 0 ? {
      type: 'Agent'
    } : _ref$agency,
    _ref$agencies = _ref.agencies,
    agencies = _ref$agencies === void 0 ? [] : _ref$agencies,
    development = _ref.development,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$onAddToWatchlist = _ref.onAddToWatchlist,
    onAddToWatchlist = _ref$onAddToWatchlist === void 0 ? () => {} : _ref$onAddToWatchlist,
    _ref$scrollableParent = _ref.scrollableParent,
    scrollableParent = _ref$scrollableParent === void 0 ? false : _ref$scrollableParent;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var listingType = listing.type;
  var buildPhotoAlt = _ref2 => {
    var street = _ref2.street,
      suburb = _ref2.suburb,
      state = _ref2.state,
      postcode = _ref2.postcode;
    var streetWithComma = street ? "".concat(street, ",") : '';
    return [streetWithComma, suburb, state, postcode].filter(value => value).join(' ').trim();
  };
  var inspectionDate = (_listing$nextInspecti = listing.nextInspection) === null || _listing$nextInspecti === void 0 ? void 0 : _listing$nextInspecti.startdate;
  var nextInspectionFormatted = inspectionDate && moment(inspectionDate).format('ddd, D MMM h:mm a');
  var eventData = {
    address,
    property,
    agency,
    listing,
    price: listing.priceLabel
  };
  return ___EmotionJSX("div", {
    className: className,
    css: styles.multipleListingCard({
      hasInspection: Boolean(inspectionDate)
    })
  }, ___EmotionJSX(AllhomesWatchlistButton, {
    css: styles.watchlistButton,
    listingId: listing.id,
    onAddToWatchlist: onAddToWatchlist,
    noText: true,
    inactiveColour: variables.colour.neutral400
  }), ___EmotionJSX("a", {
    css: styles.link,
    href: (_listing$url = listing.url) !== null && _listing$url !== void 0 ? _listing$url : undefined,
    id: "allhomes-listing-search-listings-multiple-card-listing-img-".concat(listing.id),
    onClick: () => {
      sendEvent('listing-click', eventData);
      _onClick(listing.id);
    },
    target: "_blank",
    rel: "noreferrer noopener"
  }, ___EmotionJSX(MultipleListingCardImage, {
    firstImage: listing.firstImage,
    alt: buildPhotoAlt(address)
  }), ___EmotionJSX(AllhomesListingBadges, {
    annotations: listing.annotations
  })), inspectionDate ? ___EmotionJSX("div", {
    css: styles.nextInspection
  }, ___EmotionJSX("span", {
    itemProp: "name",
    css: styles.nextInspectionLabel
  }, "Next inspection:", ' '), ___EmotionJSX("span", {
    itemProp: "startDate",
    content: inspectionDate || undefined
  }, nextInspectionFormatted)) : undefined, ___EmotionJSX("div", {
    css: styles.multipleCardDetailsOuter,
    className: "allhomes-listing-search-listings-multiple-card__details-outer"
  }, ___EmotionJSX("a", {
    css: styles.link,
    href: (_listing$url2 = listing.url) !== null && _listing$url2 !== void 0 ? _listing$url2 : undefined,
    id: "allhomes-search-listing-card-listing-details-".concat(listing.id),
    onClick: () => {
      sendEvent('listing-click', eventData);
      _onClick(listing.id);
    },
    target: "_blank",
    rel: "noreferrer noopener"
  }, ___EmotionJSX("div", {
    css: styles.multipleCardDetails,
    className: "allhomes-listing-search-listings-multiple-card__details"
  }, ___EmotionJSX("div", {
    css: styles.multipleCardDetailsPrice
  }, ___EmotionJSX("span", {
    className: "allhomes-listing-search-listings-multiple-card__details-price-main"
  }, listing.priceLabel)), ___EmotionJSX(AllhomesListingCardAddress, _extends({}, address, {
    listingId: listing.id
  })), ___EmotionJSX(AllhomesListingCardFeatures, _extends({
    eer: 0
  }, property, {
    listingType: listingType
  }))))), agency && isEqual(agency.type, 'Agent') && ___EmotionJSX("div", {
    css: styles.multipleCardDetailsAgencyLogoContainer({
      isScrollable: scrollableParent
    })
  }, ___EmotionJSX("img", {
    src: (_ref3 = (agencies === null || agencies === void 0 ? void 0 : agencies.length) <= 1 ? agency.logo : development === null || development === void 0 ? void 0 : development.logo) !== null && _ref3 !== void 0 ? _ref3 : undefined,
    css: styles.multipleCardDetailsAgencyLogo,
    alt: (_agency$name = agency.name) !== null && _agency$name !== void 0 ? _agency$name : undefined
  })));
};